import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2j7xk5pwsc: FaireBrandEntity = {
  token: "b_2j7xk5pwsc",
  type: "brand",
  name: "TheKingShirt",
  avatarUrl:
    "https://cdn.faire.com/fastly/c5d99667bcc66919fde152e1c169edf2d2ba5bd4bc9003e91a4238ddf210c3bb.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6af2bc0c8f571d913867877a2837713fb93a4bb2f9f2ecdfc58b9ed90399a625.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c5d99667bcc66919fde152e1c169edf2d2ba5bd4bc9003e91a4238ddf210c3bb.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6af2bc0c8f571d913867877a2837713fb93a4bb2f9f2ecdfc58b9ed90399a625.jpeg",
  location: "VNM",
  minimumOrderDollars: 15,
  rating: 4.8,
  reviewCount: 203,
  isTopShop: true,
  isInsider: true,
  description:
    "Thekingshirt loves originality, talent and quality. We offer a daring collection of leading edge designers from around the globe and bring them to you in one seamless shopping experience. We discover, nurture and curate to bring you a breathtaking collection.\n\nYou are not a slave to fashion. You cherish your own personal style as a leader and not a follower. You love originality and creativity and nurture your own.\n\nThekingshirt offers the most exciting emerging and established designers from around the world, as well as products from our own brand.\n\nPlease visit my website https://thekingshirt.com/\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:06.148Z",
    importedBy: "entity-db-cli",
  },
};
